import { SelectProps as $SelectProps } from 'antd/lib/select';

import { Select as $Select } from '../components/common/antd/antd-override';

export type SelectProps = $SelectProps;
export default $Select;
